import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextComponent } from './input-text/input-text.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { InputSelectComponent } from './input-select/input-select.component';
import { InputCheckComponent } from './input-check/input-check.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    InputTextComponent,
    InputSelectComponent,
    InputCheckComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    RxReactiveFormsModule,
  ],
  exports: [
    InputTextComponent,
    InputSelectComponent,
    InputCheckComponent
  ]
})
export class InputsModule { }
